import { gql } from "@apollo/client";

export const CLAIM_REFERRAL = gql`
	mutation ClaimReferral($referralId: String, $campaignId: String, $fpr: String, $city: String) {
		claimReferral(referralId: $referralId, campaignId: $campaignId, fpr: $fpr, city: $city) {
			_id
			bookingId
			description
			details
			points
			referralId
			status
			type
			userId
		}
	}
`;
